module.exports = __webpack_public_path__ + "img/1513232630.45325a52.jpg";